<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    mobile-breakpoint="991"
    persistent
    width="260"
  >
    <v-img
      class="my-4"
      :src="require('@/assets/logo.svg')"
      height="64"
      contain
    />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.path"
        active-class="tertiary"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.name" />
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import {
    mapMutations,
  } from 'vuex'
  import paths from '../../router/paths.js'
  export default {
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        links: []
      }
    },

    computed: {
      user: function () {
        return this.$store.state.user
      },
      inputValue: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      }
    },
    watch: {
      user: {
        handler: function () { this.setLinks() },
        deep: true
      }
    },
    created () {
      this.setLinks()
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
      setLinks () {
        var links = []
        if (this.user) {
          var role = this.user.role.toLowerCase()
          if (!role) {
            role = 'default'
          }
          if (this.isBetaCore(this.user)) {
            paths.forEach(path => {
              if (path.icon) {
                links.push(path)
              }
            })
          } else {
            paths.forEach(path => {
              if (path.roles && path.roles.indexOf(role.toLowerCase()) > -1) {
                links.push(path)
              }
            })
          }
        }
        this.links = links
      }
    },
  }
</script>

<style lang="scss">
.contact-button {
  width: 100%;
  margin-bottom: 17px;
  position: absolute;
  bottom: 0;
}
</style>
